import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { fetchKanbanBoards, performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { ORBModal } from '../../../ORB/components/ORBModal';

const Container = styled.div``;

const STATE = {
  approve: false,
  regplate_code: '',
  showModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class TEST_1Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset = () => {
    this.setState({ ...STATE });
    this.props.fetch();
  };

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
         {vehicle?.financestadagen}
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ showModal: true })}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {!!this.state.showModal && <ORBModal item={vehicle} onClose={this.reset} />}
      </Cell>
    );
  }
}

TEST_1Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(regplate_code) {
      if (!ownProps.cell.vehicle.id) throw 'no vehicle id';
      dispatch(performAction(ownProps.action.id, ownProps.cell.vehicle.id, { regplate_code }));
    },
    fetch: () => {
      dispatch(fetchKanbanBoards());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const TEST_1 = compose(
  withConnect,
  withRouter,
)(TEST_1Comp);
